'use strict';

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Doors.tsx
var SvgDoors = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M1.25 3c0-.966.784-1.75 1.75-1.75h9.874c.448 0 .879.172 1.204.48l8.126 7.706c.349.33.546.79.546 1.27v3.664c0 .795-.528 1.466-1.246 1.705-.502.167-1.205.427-1.902.767-.706.344-1.359.748-1.799 1.188-.927.927-1.664 2.576-2.039 3.552a1.807 1.807 0 0 1-1.677 1.168H3A1.75 1.75 0 0 1 1.25 21V3ZM3 2.75a.25.25 0 0 0-.25.25v18c0 .138.112.25.25.25h11.087a.308.308 0 0 0 .277-.206c.375-.977 1.204-2.9 2.378-4.074.612-.612 1.436-1.103 2.203-1.477a17.436 17.436 0 0 1 2.085-.841.308.308 0 0 0 .22-.282v-3.664a.25.25 0 0 0-.078-.182L13.046 2.82a.25.25 0 0 0-.172-.069H3ZM6.5 6.5V12h10.961l-5.323-5.5H6.5ZM6 5h6.35a1 1 0 0 1 .719.305l6.29 6.5c.614.634.165 1.695-.718 1.695H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm-.25 10.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z" }));
var Doors_default = SvgDoors;

module.exports = Doors_default;
